/*
* Resideo/LifeWhere
* Copyright (C) 2018-2023 Resideo/LifeWhere
* mailto:nathan.williams@resideo.com
*/

import http from "../http-common";

let controller = "/house";
controller += "?api-version=2.0";
class HomeService {
    
    async get(id, parentOrganizationId) {
        const response = await http.get(`${controller}&organizationId=${id}&parentOrganizationId=${parentOrganizationId}`); 
        const data = await response;
        return data;
    }

    add(data) {
        return http.post(`${controller}`, data);
    }

    update(data) {
        return http.put(`${controller}`, data);        
    }

    delete(id, customerId, partnerId) {
        return http.delete(`${controller}&houseAssetId=${id}&organizationId=${customerId}&parentOrganizationId=${partnerId}`);
    }

}

export default new HomeService();